import { Button } from '@billda/design-system';
import { DeleteIcon, EditIcon } from '@billda/design-system';

interface GroupsActions {
  onEdit: () => void;
  onDelete: () => void;
}

export function GroupActions({ onEdit, onDelete }: GroupsActions) {
  return (
    <div className="flex gap-3 border-t border-border-default pt-5">
      <Button
        variant="neutral"
        onClick={onEdit}
        fullWidth
        data-testid="edit-group-button"
      >
        <EditIcon aria-hidden="true" className="size-4" />
        Edit group
      </Button>
      <Button
        variant="outlineDanger"
        onClick={onDelete}
        aria-label="Delete group"
        data-testid="delete-group-button"
      >
        <DeleteIcon aria-hidden="true" className="size-4" />
        <span className="hidden sm:inline">Delete</span>
      </Button>
    </div>
  );
}
